import colors from "assets/scss/colors.scss";

export const backgroundGrid = {
  height: "100%",
  paddingLeft: { xs: 10, sm: 15, md: 20, lg: 0 },
  paddingRight: { xs: 10, sm: 15, md: 20, lg: 0 },
  paddingTop: 10,
  paddingBottom: 10,
  backgroundImage: colors.loginBackground,
};

export const whiteContentGrid = {
  paddingLeft: 4,
  paddingRight: 4,
  paddingTop: 4,
  height: 500,
  width: { lg: 532, md: 426, sm: 400, xs: "auto" },
  maxWidth: 512,
  bgcolor: colors.primaryColor,
  boxShadow:
    "0px 3px 3px -2px rgb(0 0 0 /20%), 0px 3px 4px 0px rgb(0 0 0 / 50%), 0px 1px 8px 0px rgb(0 0 0 / 40%)",
  display: "flex",
  justifyContent: "center",
  borderRadius: 2,
  paddingBottom: 4,
};

export const forgotPasswordTypography = {
  textDecoration: "none",
  cursor: "pointer",
  py: 2,
};
